import { createAction, props } from '@ngrx/store';
import { SortDropdownOption } from '@immosky/types';

export enum SortActions {
  Reset = '[Filter] Reset Sort',
  Set = '[Filter] Set Sort',
}

export const resetSort = createAction(SortActions.Reset);

export const setSort = createAction(
  SortActions.Set,
  props<{ sort: SortDropdownOption }>()
);
